import React from 'react'
import logo from '../../luniImages/logo.png'
import './Logo.css'
import { Link } from 'react-router-dom'

export default function Logo() {
    return (
        <div className="logoImg">
            <Link to={{ pathname: '/' }}>
                <img src={logo} alt="logo" />
            </Link>
        </div>
    )
}
